import * as THREE from 'three';
import { SectionConfig, SectionRect, SectionInterface } from '../types';
import { createGlassPane } from '../geometry/GlassGeometry';
import { createRoedenPattern } from '../geometry/RoedenGeometry';
import { MaterialLibrary } from '../materials/MaterialLibrary';
import { PROFILE } from '../utils/profileConstants';

/**
 * FIX: Non-openable fixed light. Glass sits directly in the frame/divider pocket.
 * No sash, no handle.
 */
export class FixSection implements SectionInterface {
  readonly group: THREE.Group;

  constructor(config: SectionConfig, rect: SectionRect, materialLib: MaterialLibrary) {
    this.group = new THREE.Group();
    this.group.name = `section-fix-${rect.index}`;
    this.group.userData = { sectionIndex: rect.index, sectionType: 'FIX' };

    const clearW = rect.width;
    const clearH = rect.height;
    const thickness = PROFILE.glassThickness;

    // Glass pane
    const glass = createGlassPane(
      clearW,
      clearH,
      thickness,
      materialLib.glass(config.infill.tint, config.infill.glazingTier),
    );
    glass.position.set(clearW / 2, clearH / 2, 0);
    this.group.add(glass);

    // Roeden
    if (config.roeden.pattern !== 'none' && config.roeden.mode !== 'none') {
      const roeden = createRoedenPattern(
        clearW, clearH, config.roeden,
        materialLib.roedenMaterial(),
      );
      roeden.position.set(clearW / 2, clearH / 2, 0);
      this.group.add(roeden);
    }

    this.group.position.set(rect.x, rect.y, 0);
  }
}
